import { render, staticRenderFns } from "./anamnese.vue?vue&type=template&id=24aa3386&"
import script from "./anamnese.js?vue&type=script&lang=js&"
export * from "./anamnese.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports